export default __webpack_public_path__ + "static/media/ref_icon.405e0242.svg";